import { AlertSeverityType } from '@ecdlink/ui';

/**
 * Stable walkthrough-only client list.
 * Used so QA/tours never depend on the HCW's real caseload.
 */
export type DummyClientKind = 'mother' | 'infant';

export type DummyClient = {
  id: string;
  kind: DummyClientKind;
  title: string;
  subTitle: string;
  alertSeverity: AlertSeverityType;
};

export const DUMMY_CLIENTS: DummyClient[] = [
  {
    id: 'walkthrough-mother-1',
    kind: 'mother',
    title: 'Thandi Molefe',
    subTitle: 'Visit 3 due soon',
    alertSeverity: 'warning',
  },
  {
    id: 'walkthrough-mother-2',
    kind: 'mother',
    title: 'Lerato Dlamini',
    subTitle: 'New client',
    alertSeverity: 'none',
  },
  {
    id: 'walkthrough-mother-3',
    kind: 'mother',
    title: 'Nomsa Khumalo',
    subTitle: 'Visit 2 overdue',
    alertSeverity: 'error',
  },
  {
    id: 'walkthrough-infant-1',
    kind: 'infant',
    title: 'Sipho & Thandi',
    subTitle: 'Growing well',
    alertSeverity: 'success',
  },
  {
    id: 'walkthrough-infant-2',
    kind: 'infant',
    title: 'Amahle & Lerato',
    subTitle: 'Visit 1 due',
    alertSeverity: 'warning',
  },
  {
    id: 'walkthrough-infant-3',
    kind: 'infant',
    title: 'Bongani & Nomsa',
    subTitle: 'No visit',
    alertSeverity: 'none',
  },
];

/** Dummy caseload always qualifies for the multi-client tour script. */
export const DUMMY_CLIENT_COUNT = DUMMY_CLIENTS.length;
